import NewsEditPage from './NewsEditPage';

export default NewsEditPage;
